import { PageShell } from '@/shared/components';
import { OrgChartTab } from '@/features/accountability/components/tabs/OrgChartTab';

export function HrisOrgChartPage() {
  return (
    <PageShell>
      <div className="flex min-h-[calc(100vh-240px)]">
        <div className="flex-1 min-w-0 overflow-auto">
          <OrgChartTab />
        </div>
      </div>
    </PageShell>
  );
}
